// src/pages/dashboard/components/MissionPerformance.js
import React, { useState, useEffect } from 'react';

const MissionPerformance = () => {
  const [missions, setMissions] = useState([]);

  useEffect(() => {
    // Simulate API call to fetch mission performance
    const fetchMissions = async () => {
      const response = await fetch('/api/mission-performance'); // Replace with real API endpoint
      const data = await response.json();
      setMissions(data);
    };

    fetchMissions();
  }, []);

  return (
    <div>
      <h3>Mission Performance</h3>
      <ul>
        {missions.map((mission) => (
          <li key={mission.Id}>
            Mission ID: {mission.Id}, Status: {mission.Status}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MissionPerformance;
